// extracted by mini-css-extract-plugin
export var CardContainer = "FlipCard-module--CardContainer--2c-GR";
export var Front = "FlipCard-module--Front--2uZzK";
export var Back = "FlipCard-module--Back--1VEA7";
export var Rule = "FlipCard-module--Rule--1gULl";
export var Icon = "FlipCard-module--Icon--8R-o0";